import axios, { ExtendAxiosRequestConfig } from './axios'
import { flat } from './functional'

function normalize (base: string, path: string) {
  return new URL(base ? `${base}/${path}` : path, location.origin).href
}
export default class Resource {
  private base: string

  constructor(base: string) {
    this.base = base
  }

  get<T> (
    id: string | ExtendAxiosRequestConfig,
    options?: ExtendAxiosRequestConfig
  ) {
    let url = this.base
    if (typeof id === 'object') {
      options = id
    } else if (id !== undefined) {
      url = normalize(this.base, id)
    }
    if (options?.autoPageTurning) {
      options.params = Object.assign(options.params || {}, {
        page: 1,
        size: 20
      })
    }
    return axios.get(url, options).then(async (res) => {
      if (!res.data.code || res.data.code === '0') {
        if (options?.autoPageTurning && res.data && res.data.count > 20) {
          const ret = res.data.result
          const total = Math.ceil(res.data.count / 20)
          const promiseArr = []
          for (let i = 2; i <= total; i++) {
            options!.params.page = i
            promiseArr.push(axios.get(url, options).then(res => res.data.result))
          }
          ret.push(...flat(await Promise.all(promiseArr)))
          return ret as T
        }
        return res.data.result as T
      } else {
        return Promise.reject(new Error(res.data.message))
      }
    })
  }

  post<T> (
    id: string | ExtendAxiosRequestConfig,
    body?: any,
    options?: ExtendAxiosRequestConfig
  ) {
    let url = this.base
    if (typeof id === 'object') {
      options = body
      body = id
    } else if (id !== undefined) {
      url = normalize(this.base, id)
    }
    if (options?.autoPageTurning) {
      options.params = Object.assign(options.params || {}, {
        page: 1,
        size: 20
      })
    }
    return axios.post(url, body, options).then(async (res) => {
      if (!res.data.code || res.data.code === '0') {
        if (options?.autoPageTurning && res.data && res.data.count > 20) {
          const ret = res.data.result
          const total = Math.ceil(res.data.count / 20)
          const promiseArr = []
          for (let i = 2; i <= total; i++) {
            options!.params.page = i
            promiseArr.push(axios.post(url, body, options).then(res => res.data.result))
          }
          ret.push(...flat(await Promise.all(promiseArr)))
          return ret as T
        }
        return res.data.result as T
      } else {
        return Promise.reject(new Error(res.data.message))
      }
    })
  }
  put<T> (
    id: string | ExtendAxiosRequestConfig,
    body: any,
    options?: ExtendAxiosRequestConfig
  ) {
    let url = this.base
    if (typeof id === 'object') {
      options = body
      body = id
    } else if (id !== undefined) {
      url = normalize(this.base, id)
    }
    return axios.put(url, body, options).then((res) => {
      if (!res.data.code || res.data.code === '0') {
        return res.data.result as T
      } else {
        return Promise.reject(new Error(res.data.message))
      }
    })
  }
  patch<T> (
    id: string | ExtendAxiosRequestConfig,
    body: any,
    options?: ExtendAxiosRequestConfig
  ) {
    let url = this.base
    if (typeof id === 'object') {
      options = body
      body = id
    } else if (id !== undefined) {
      url = normalize(this.base, id)
    }
    return axios.patch(url, body, options).then((res) => {
      if (!res.data.code || res.data.code === '0') {
        return res.data.result as T
      } else {
        return Promise.reject(new Error(res.data.message))
      }
    })
  }
  delete<T> (id: string, options?: ExtendAxiosRequestConfig) {
    const url = normalize(this.base, id)
    return axios.delete(url, options).then((res) => {
      if (!res.data.code || res.data.code === '0') {
        return res.data.result as T
      } else {
        return Promise.reject(new Error(res.data.message))
      }
    })
  }
}
